import { Fragment, useEffect, useState } from "react";

import ConfirmationModal2 from "@bokio/components/ConfirmationModal2/ConfirmationModal2";
import { useToggle } from "@bokio/hooks/useToggle/useToggle";
import { AccountingLangFactory, GeneralLangFactory } from "@bokio/lang";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { useLazyApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";
import { getRoute } from "@bokio/shared/route";
import classes from "@bokio/utils/classes";

import { ReceiptPageView } from "../ReceiptPageView/ReceiptPageView";

import * as styles from "../../receipt.scss";

interface ReceiptExtraPageProps {
	companyId: string;
	pageId: string;
	allowRotate?: boolean;
	allowDelete?: boolean;
	maxWidth?: string;
	onRemove?: () => void;
	isPdf: boolean;
	pageVersion?: number;
	extension: string;
	page: number;
}

export const ReceiptExtraPage = (props: ReceiptExtraPageProps) => {
	const accountingLang = AccountingLangFactory();
	const generalLang = GeneralLangFactory();
	const { allowDelete, allowRotate, maxWidth, isPdf, pageId, extension, onRemove, pageVersion, page } = props;

	const {
		companyInfo: { Id: companyId },
	} = useCompanyInfo();
	const [showDelete, toggleShowDelete] = useToggle(false);
	const [version, setVersion] = useState(pageVersion);

	useEffect(() => setVersion(pageVersion), [pageVersion]);

	const [rotate, rotateRequest] = useLazyApi(proxy.Accounting.ReceiptController.RotateExtraPage.Post, {
		onSuccess: version => {
			setVersion(version);
		},
	});

	const [deleteReceipt, deleteRequest] = useLazyApi(proxy.Accounting.ReceiptController.DeleteExtraPage.Post, {
		onSuccess: () => {
			onRemove && onRemove();
		},
	});

	const className = classes(styles, "img", {
		maxWidth: maxWidth,
	});

	const src = getRoute("receiptExtraImage", { company: companyId, imageId: pageId }, { v: version });

	return (
		<Fragment>
			<ReceiptPageView
				isPdf={isPdf}
				downloadUrl={!isPdf ? src : undefined}
				download={!isPdf ? page + extension : undefined}
				imageUrl={src}
				onRotate={() => (allowRotate && !isPdf ? rotate(companyId, pageId) : undefined)}
				onDelete={allowDelete && !isPdf ? toggleShowDelete : undefined}
				isRotating={rotateRequest.isLoading}
				isDeleting={deleteRequest.isLoading}
			/>
			<ConfirmationModal2
				title={accountingLang.Todo_ConfirmDelete_Title}
				submitText={generalLang.Delete}
				onConfirm={() => deleteReceipt(companyId, pageId)}
				isDelete={true}
				isVisible={showDelete}
				isLoading={deleteRequest.isLoading}
				onCancel={toggleShowDelete}
			>
				<img alt={generalLang.Receipt} id="img" className={className} src={src} />
			</ConfirmationModal2>
		</Fragment>
	);
};
